import { Row, Col, Typography, Card } from 'antd'
import { t } from 'i18next'
import React from 'react'

const { Text } = Typography

const CategoryTitleHelp = () => {
  const guide = {
    '{mm/yy}': 'monthYearShort',
    '{mm/yyyy}': 'monthYearLong',
    '{mm/yy} - {mm/yy}': 'monthYearGapShort',
    '{mm/yyyy} - {mm/yyyy}': 'monthYearGapLong',
    '{dd/mm/yyyy}': 'dayWeekYear',
    '{yyyy}': 'onlyYear',
    '{dd}': 'dayShort',
    '{dddd}': 'dayLong',
    '{dd} - {dd}': 'dayGapShort',
    '{dddd} - {dddd}': 'dayGapLong',
    '{w/yyyy}': 'weekYear',
    '{w}': 'week',
    '{w} - {w}': 'weekGap',
    '{dataType}': 'dataTypeGuide',
    '{function}': 'functionGuide',
    '{keyFigure}': 'keyfigureGuide',
    '{formula}': 'formulaGuide',
    '{scenarioName}': 'scenarioNameGuide',
    '{dimensionName}': 'dimensionNameGuide',
    '{company}': 'companyGuide'
  }

  return (
    <Card title={t('customReportPage:guideForTranslator')}>
      {Object.entries(guide).map(([key, value]) => (
        <Row key={key} style={{ margin: 8 }}>
          <Col span={8}>
            <Text copyable code>
              {key}
            </Text>
          </Col>
          <Col span={16}>{t(`customReportPage:${value}`)}</Col>
        </Row>
      ))}
      <Row style={{ margin: 8 }}>
        <Col span={8}>
          <Text copyable code>
            {t('customReportPage:freeText')}
          </Text>
        </Col>
        <Col span={16}>{t('customReportPage:freeTextInfo')}</Col>
      </Row>
    </Card>
  )
}

export default CategoryTitleHelp
